import React, { useEffect } from "react";
import { Notifications, useToast } from "@/components/ui/toast";
import { subscribeUnhandledFailures } from "@/lib/unhandled-failures";

/** Shows a failed action no page reported (lib/unhandled-failures.ts). Mounted once. */
export function UnhandledFailureNotice(): React.ReactElement {
  const { toast, error, showError, hideToast, dismissError } = useToast();
  useEffect(
    () => subscribeUnhandledFailures((message) => showError(message, { reportAs: "unhandled_failure" })),
    [showError],
  );
  return (
    <div className="contents" data-testid="unhandled-failure-notice">
      <Notifications toast={toast} error={error} onCloseToast={hideToast} onDismissError={dismissError} />
    </div>
  );
}
